const endGameMessageObj = {
  yourScore: "Your Score: ",
  highScore: "High Score: ",
};

export default endGameMessageObj;
